import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .MuiFormControl-marginNormal {
    justify-content: center;

    margin-top: 0px;
    margin-bottom: 0px;

    height: 44px;

    width: 100%;

    border-radius: 5px;

    padding: 12px 10px;

    border: 1px solid ${colors.grayLight};
  }

  .MuiInputBase-root {
    font-size: 11px;
  }

  .MuiInputBase-input {
    text-align: center;
  }
`
export const StyledError = styled.p`
  width: 100%;
  color: red;
  font-weight: 400;
  font-size: 12px;
  margin-top: 5px;
  margin: 0px 10px;
  padding: 12px 10px;
`
